import { env } from "@/env";

export const isApeTheme = env.NEXT_PUBLIC_THEME === "ape";
